import { render } from "./MyContracts.vue?vue&type=template&id=87ba1040&scoped=true"
import script from "./MyContracts.vue?vue&type=script&lang=js"
export * from "./MyContracts.vue?vue&type=script&lang=js"

import "./MyContracts.vue?vue&type=style&index=0&id=87ba1040&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ba1040"]])

export default __exports__